/**
 * LINDIE Dark Mode Toggle
 * Ported from DarkModeToggle.jsx — vanilla JS, no dependencies
 * Sets data-theme attribute on <html>, persists to localStorage
 */
(function () {
  const STORAGE_KEY = 'lindie-theme';
  const html = document.documentElement;

  // Apply saved theme immediately (before DOM ready) to prevent flash
  const saved = localStorage.getItem(STORAGE_KEY);
  const isDark = saved ? saved === 'dark' : true; // default: dark
  html.setAttribute('data-theme', isDark ? 'dark' : 'light');

  function initToggle() {
    const toggles = document.querySelectorAll('.js-dark-mode-toggle');
    if (!toggles.length) return;

    // Sync toggle UI state on load
    toggles.forEach(function (btn) {
      if (isDark) btn.classList.add('dark-mode-toggle--active');
      else btn.classList.remove('dark-mode-toggle--active');
    });

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const currentTheme = html.getAttribute('data-theme');
        const nextDark = currentTheme !== 'dark';
        const nextTheme = nextDark ? 'dark' : 'light';

        html.setAttribute('data-theme', nextTheme);
        localStorage.setItem(STORAGE_KEY, nextTheme);

        // Sync all toggles on page
        document.querySelectorAll('.js-dark-mode-toggle').forEach(function (t) {
          if (nextDark) t.classList.add('dark-mode-toggle--active');
          else t.classList.remove('dark-mode-toggle--active');
          t.setAttribute('aria-checked', String(nextDark));
        });
      });
    });
  }

  // Init when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToggle);
  } else {
    initToggle();
  }

  // Re-init on Shopify section re-render (theme editor)
  document.addEventListener('shopify:section:load', initToggle);
})();
